import { useEffect, type FC } from "react";
// From react-router-dom, like the other 86 files that use the router.
// Importing the same hook from the bare package is not a style choice: the
// two entry points resolve to different module instances under a resolver
// that hands one of them CommonJS, and a second instance has its own
// context, so this hook threw "useLocation() may be used only in the
// context of a <Router>" while sitting directly inside one.
import { useLocation } from "react-router-dom";

type Props = {
  children: React.ReactNode;
};

const ScrollToTop: FC<Props> = (props) => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return <>{props.children}</>;
};

export default ScrollToTop;
